import * as React from 'react';
import moment, {Moment} from "moment";
import styled from "styled-components";
import {transition} from "helpers/css";

export interface ArticleCardProps {
  title: string;
  previewSrc: string;
  shortDescription: string;
  created: Moment | Date;
}

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 360px;
  min-height: 432px;

  background-color: white;
  border: 1px solid #EDF0F5;
  box-sizing: border-box;
  box-shadow: 10px 5px 10px rgba(208, 211, 219, 0.1);
  border-radius: 10px;
  overflow: hidden;
  
  ${transition()}
`;

const Wrapper = styled.div`
  cursor: pointer;
  
  &:hover {
    ${Container} {
      transform: translateY(-4px);
    }
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const Preview = styled.div`
  width: 360px;
  height: 220px;
  overflow: hidden;
  
  img {
    width: 100%;
    object-fit: cover;
  }
`;

const Date = styled.div`
  font-size: 10px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0.1em;
  color: #C1C3C8;
  
  margin-top: auto;
`;

const Title = styled.div`
  margin-top: 10px;
  margin-bottom: 6px;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: 0.01em;
  color: #29292B;
  max-height: 300px;
  overflow: hidden;
`;

const Description = styled.div`
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  letter-spacing: 0.01em;
  max-height: 303px;
  overflow: hidden;
`;

const Button = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
  font-size: 10px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0.1em;
  color: #3264EF;
  text-transform: uppercase;
  cursor: pointer;
  transition: color .3s;
  
  &:hover {
    color: lighten(#3264EF, 3%);
  }
`;

/**
 * @return {React.ReactElement}
 * @constructor
 */

export default function ArticleCard(
  props: ArticleCardProps
): React.ReactElement {

  return (
    <Wrapper>
      <Container>
        <Preview>
          <img src={props.previewSrc} alt=""/>
        </Preview>
        <Content>
          <Date>{moment(props.created).format('DD.MM.YYYY')}</Date>
          <Title>{props.title}</Title>
          <Description>{props.shortDescription}</Description>

          <Button>подбробнее {'->'}</Button>
        </Content>
      </Container>
    </Wrapper>
  )
}